import React, { useState, useEffect } from 'react';

const Picfetch = ({ id }) => {
    const [pic, setPic] = useState('');

    useEffect(() => {
        let isMounted = true;
        // fetch('http://localhost:5000/api/get_photo') 
        //     .then(response => {
        //         if (!response.ok) {
        //             throw new Error('Network response was not ok');
        //         }
        //         return response.json();
        //     })
        //     .then(picData => {
        //         if (isMounted) { 
        //             setPic(`data:image/png;base64,${picData.data}`);
        //         }
        //     })
        //     .catch(error => {
        //         console.error('Fetching error:', error);
        //     });
        const fetchData = async () => {
            console.log(id);
            try {
                const response = await fetch('https://dandeline.tongji.edu.cn/api/get_photo', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "agentId": "200027",
                        "agentSecret": "QE_pa9KHh84YbAMbhs0PcthBoWtrBA7QNY00Qz67RaI",
                        "teacher_id": id
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                if (isMounted) {
                    setPic(`data:image/png;base64,${data.base64}`);
                }
            } catch (error) {
                if (isMounted) {
                    console.error('Fetching error:', error);
                    setPic('');
                }
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [id]);

    return (
        <div>
            {pic && <img src={pic} alt="Base64 Image" />}
        </div>
    )

}

export default Picfetch;